import React from 'react';
const SendAppIcon = () => {
    return (React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { "clip-path": "url(#clip0_58301_12058)" },
            React.createElement("path", { d: "M5.89756 7.96259L7.9859 5.86842M4.31673 3.68676L9.26923 2.03592C11.4917 1.29509 12.6992 2.50842 11.9642 4.73092L10.3134 9.68342C9.20506 13.0143 7.38506 13.0143 6.27673 9.68342L5.78673 8.21342L4.31673 7.72342C0.985895 6.61509 0.985895 4.80092 4.31673 3.68676Z", stroke: "#0066F4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_58301_12058" },
                React.createElement("rect", { width: "14", height: "14", fill: "white" })))));
};
export default SendAppIcon;
